<!--
 * @Author: your name
 * @Date: 2021-12-15 11:38:15
 * @LastEditTime: 2021-12-23 16:17:28
 * @LastEditors: Please set LastEditors
 * @Description:无人车
 * @FilePath: \new-website-1123\src\views\special\car\index.vue
-->
<template>
  <div class="xj101-page">
    <page1></page1>
    <div class="sticky-box1">
      <div class="sticky-child">
        <page2></page2>
      </div>
    </div>
    <page3
      class="opacity-page scale-page"
      url="https://stkjiot.com/resources/special/xj101/2.png"
      style="background-size: 80%; background-position: center bottom"
    >
      <span class="label-s">强劲动力系统</span>
      <p class="p-24">
        高性能电机瞬间动力输出，更高效、更持续；四轮驱动，扭矩达到新高度
      </p>
    </page3>

    <page4 class="opacity-page scale-page"></page4>

    <page3
      class="opacity-page scale-page"
      url="https://stkjiot.com/resources/special/xj101/5.jpg"
    >
      <span class="label-s">多负载拓展 ,突破单一</span>
      <p class="p-24">搭载拓展模块，自由开发任务系统。</p>
    </page3>
  </div>
</template>

<script>
import page1 from "./page1.vue";
import page2 from "./page2.vue";
import page3 from "./page3.vue";
import page4 from "./page4.vue";
export default {
  name: "",
  components: {
    page1,
    page2,
    page3,
    page4,
  },
  data() {
    return {
      scrollTop: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.cScroll, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.cScroll, false);
  },
  methods: {
    /**
     * @description: 监听滚动事件
     */
    cScroll() {
      let html = document.querySelector("html");
      this.scrollTop = html.scrollTop;
      if (window.innerWidth > 800) {
        this.page2s();
      }
    },
    page2s() {
      let box2 = document.querySelector(".sticky-box1");
      let div = box2.querySelector(".xj101-page2");
      let img = box2.querySelector(".img-div");
      let text1 = div.querySelector(".text1-div");
      let text2 = div.querySelector(".text2-div");
      let topLabel = text1.querySelector(".t-top");
      let topDesc = text1.querySelector(".desc-p");
      let msg = text1.querySelector(".msg-ul");
      let filterBox = div.querySelector(".filter-div");

      let ctop = this.scrollTop - box2.offsetTop;
      if (ctop > 2100) {
        let rate = Math.min(1, (ctop - 2100) / 300);
        text2.style.opacity = rate;
        text1.style.opacity = 0;
        filterBox.style.opacity = 1;
      } else if (ctop > 1800) {
        let rate = Math.min(1, (ctop - 1800) / 300);
        text2.style.opacity = 0;
        text1.style.opacity = 1 - rate;
        filterBox.style.opacity = rate;
      } else if (ctop > 1600) {
        text1.style.opacity = 1;
        topLabel.style.transform = `translateY(0%)`;
        msg.style.opacity = topDesc.style.opacity = 1;
        msg.style.transform = `translateY(0%)`;
        text1.style.opacity = 1;
      } else if (ctop > 1200) {
        let rate = Math.min(1, (ctop - 1200) / 400);
        topLabel.style.transform = `translateY(${(1 - rate) * 100}%)`;
        msg.style.opacity = topDesc.style.opacity = rate;
        msg.style.transform = `translateY(-${(1 - rate) * 20}%)`;
        text1.style.opacity = 1;
      } else if (ctop > 700) {
        msg.style.opacity = topDesc.style.opacity = 0;
        topLabel.style.transform = `translateY(100%)`;
        let rate = (ctop - 700) / 500;
        let scale = Math.max(1, (1 - rate) * 4);
        text1.style.transform = `scale(${scale})`;
        topLabel.style.opacity = rate;
      } else if (ctop > 200) {
        topLabel.style.opacity = 0;
        let rate = (ctop - 200) / 500;
        img.style.width = 40 + rate * 10 + "%";
        img.style.transform = `translateY(${rate * 50}px)`;
      } else if (ctop < 200) {
        topLabel.style.opacity = 0;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.sticky-child {
  position: sticky;
  top: 0;
}
.sticky-box1 {
  height: calc(100vh + 2700px);
}
@media screen and (max-width: $mobile-width) {
  .sticky-child {
    position: relative;
    top: 0;
  }
  .sticky-box1 {
    height: auto;
  }
}
</style>
